/**
 * Optional lazy chunks (analytics SDK, Sentry replay) must never trigger the
 * stale-deploy self-heal reload in main.tsx.
 *
 * Vite's preload helper fires `vite:preloadError` BEFORE an import's own
 * `.catch` runs, and main.tsx answers that event with `location.reload()`. So a
 * flaky network (or a deploy mid-load) failing the PostHog or replay chunk
 * reloaded the whole page ~150 ms after load — mid-typing on the Gateway
 * (review of 1.3.160). Wrap those imports in `optionalImport`; while one is in
 * flight the handler lets the import fail quietly into its own catch instead.
 */
let inFlight = 0;

export function optionalImport<T>(load: () => Promise<T>): Promise<T> {
  inFlight += 1;
  let p: Promise<T>;
  try {
    p = load();
  } catch (err) {
    inFlight -= 1;
    return Promise.reject(err);
  }
  return p.finally(() => {
    inFlight -= 1;
  });
}

/** True while an optional chunk is loading (main.tsx's preloadError handler). */
export function optionalChunkLoading(): boolean {
  return inFlight > 0;
}
